<ng-container *ngIf="cards$ | async as cards">
  <div class="d-flex rounded overflow-hidden card-bar cursor-pointer" #selectedMemberElement>
    <div (click)="showPopup = !showPopup" class="bg-white p-2 rounded d-flex align-items-center w-100">
      <ng-container *ngIf="currentMemberCard">
        <span class="font-size-14">
          Sec: {{ currentMemberCard.Area }} / Row: {{ currentMemberCard.Row }} / Seat: {{ currentMemberCard.Seat }}
        </span>
      </ng-container>
      <span class="icon material-icons font-size-18 fw-bold ms-lg-4 ms-auto">{{ showPopup ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
    </div>
  </div>

  <div [hidden]="!showPopup" #seatSelection class="card-selection">
    <ng-container>
      <div class="rounded bg-white shadow p-2">
        <ng-container *ngFor="let card of cards">
          <a
            (click)="loginWithCard(card.MemberId)"
            routerLinkActive="router-link-active"
            class="cursor-pointer"
            ngbDropdownItem
            [disabled]="card.MemberId == currentMemberId"
          >
            <div class="dropdown-link mt-1 ms-1 text-left">
              <div class="font-size-14 text-start" [ngClass]="card.MemberId == currentMemberId ? 'text-secondary' : 'text-grey'">
                Sec: {{ card.Area }} / Row: {{ card.Row }} / Seat: {{ card.Seat }}
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
